import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=2e832d54&scoped=true"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=2e832d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e832d54",
  null
  
)

export default component.exports